import React from 'react'

export const TYPES = [
  {
    name: 'Entrega',
    color: '#2eb85c',
    bcolor: 'success',
  },
  {
    name: 'Cambio',
    color: '#39f',
    bcolor: 'info',
  },
  {
    name: 'Retiro',
    color: '#e55353',
    bcolor: 'danger',
  },
]

export const StateColors = [
  {
    name: 'Creado',
    color: 'info',
  },
  {
    name: 'Asignado',
    color: 'warning',
  },
  {
    name: 'Iniciado',
    color: 'stateColor-1',
  },
  {
    name: 'Vaciado',
    color: 'secondary',
  },
  {
    name: 'Retirado',
    color: 'warning',
  },
  {
    name: 'Colocado',
    color: 'success',
  },
  {
    name: 'Cambiado',
    color: 'primary',
  },
  {
    name: 'Problema',
    color: 'danger',
  },
  {
    name: 'Finalizado',
    color: 'secondary',
  },
  {
    name: 'Cancelado',
    color: 'black',
  },
  {
    name: 'Retiro Confirmado',
    color: 'success',
  },
  {
    name: 'Desasignado',
    color: 'primary-gradient',
  },
  {
    name: 'No Encontrado',
    color: 'danger',
  },
]

export const MapButtons = {
  PARA_ASIGNAR: 'Para Asignar',
  ASIGNADOS: 'Asignados',
  INICIADOS: 'Iniciados',
}

export const Maps = {
  MAPK: 'AIzaSyCj02LfLSPmbjiBuTKv4bkl9rie_B7p9eY',
  LIBRARIES: ['geometry', 'places'],
}

export const Roles = {
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_USER: 'ROLE_USER',
  ROLE_DRIVER: 'ROLE_DRIVER',
  ROLE_ADMIN_DEMO: 'ROLE_ADMIN_DEMO',
}

export const States = [
  'VACIADO',
  'RETIRADO',
  'COLOCADO',
  'CAMBIADO',
  'PROBLEMA',
  'FINALIZADO',
  'CANCELADO',
]

export const Loading = () => (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)
